import { takeLatest, put, call } from 'redux-saga/effects';
import { changeProperty, selectProperty } from '@/features/session/sessionSlice';
import { changeProperty as changePropertyAPI } from '@/api/sessionAPI';

// Saga to handle user login
function* handleChangeProperty(action) {
  try {
    const propertyData = action.payload;

    // Call the authenticateUser API function with the username and password
    yield call(changePropertyAPI, propertyData);
    // Dispatch the loginUserSuccess action with the user data

    yield put(selectProperty(propertyData.propertyId));
  } catch (error) {
    // If there is an error, dispatch the loginUserFailure action with the error message
    //yield put(loginUserFailure(error.message));
    console.log(error);
  }
}

// Watcher saga
function* propertySaga() {
  // Listen for the loginUser action and call the handleLogin saga when dispatched
  yield takeLatest(changeProperty.type, handleChangeProperty);
}

export default propertySaga;
